module.exports = __webpack_public_path__ + "img/general_george_custers_hairbrush.c7bd4c50.jpg";